"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_SPACER_SIZE = void 0;
const MIN_SPACER_SIZE = 0;
exports.MIN_SPACER_SIZE = MIN_SPACER_SIZE;
//# sourceMappingURL=constants.js.map